import { render, staticRenderFns } from "./appointmentHandler.vue?vue&type=template&id=bdec204e&scoped=true"
import script from "./appointmentHandler.vue?vue&type=script&lang=js"
export * from "./appointmentHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdec204e",
  null
  
)

export default component.exports